import type {
  ObjectWorkspaceObject,
  ObjectWorkspacePatientDetailsState,
} from '@heidi/agents';
import type { PatientProfile } from '@heidi/patients/contracts';

export type PatientIdentityProfile = Pick<
  PatientProfile,
  | 'id'
  | 'first_name'
  | 'last_name'
  | 'demographic_string'
  | 'birth_date'
  | 'gender'
  | 'email'
  | 'phone'
  | 'past_medical_history'
  | 'current_medications'
  | 'allergies'
  | 'additional_context'
>;

interface ResolvePatientDetailsStateOptions {
  object: ObjectWorkspaceObject;
  patientProfiles: readonly PatientIdentityProfile[];
  isLoading: boolean;
  isError: boolean;
}

export function resolvePatientDetailsState({
  object,
  patientProfiles,
  isLoading,
  isError,
}: ResolvePatientDetailsStateOptions): ObjectWorkspacePatientDetailsState | undefined {
  if (object.kind !== 'patient' || !object.patientProfileId) return undefined;
  if (isLoading) return { status: 'loading' };

  const patientProfile = patientProfiles.find(
    (profile) => profile.id === object.patientProfileId
  );
  if (isError || !patientProfile) return { status: 'error' };

  return {
    status: 'ready',
    details: {
      birthDate: patientProfile.birth_date,
      gender: patientProfile.gender,
      email: patientProfile.email,
      phone: patientProfile.phone,
      pastMedicalHistory: patientProfile.past_medical_history,
      currentMedications: patientProfile.current_medications,
      allergies: patientProfile.allergies,
      additionalNotes: patientProfile.additional_context,
    },
  };
}
